/** Maps a tag colour token to its `bg-dep-*` Tailwind class. */
export const tagColorClasses = {
    grey: 'bg-dep-shade-300',
    yellow: 'bg-dep-yellow-400',
    pink: 'bg-dep-pink-300',
    purple: 'bg-dep-purple-300',
    blue: 'bg-dep-blue-300',
    green: 'bg-dep-green-300',
    red: 'bg-dep-red-300',
};
